import { render } from "./ScrollabelPhotos.vue?vue&type=template&id=fc03387a&scoped=true"
import script from "./ScrollabelPhotos.vue?vue&type=script&lang=js"
export * from "./ScrollabelPhotos.vue?vue&type=script&lang=js"

import "./ScrollabelPhotos.vue?vue&type=style&index=0&id=fc03387a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc03387a"]])

export default __exports__